/**
 * Test IDs for QA automation.
 */
export const testIds = {
  receiverCommoditiesSectionCommodityPicker: "receiver-commodities-section-commodity-picker",
  receiverCommoditiesSectionCommoditySearch: "receiver-commodities-section-commodity-search",
} as const;
